import {
  Fact
} from '../../common/fact';

require('./facts-slider-view.component.scss');

class FactsSliderViewController {
  constructor($scope, $element) {
    this.$scope = $scope;
    this.isImage = Fact.isImage;
    this.getImageFileName = Fact.getImageFileName;
    this.$element = $element;
  }

  get selectedImage() {
    if (!this.selectedFact) return null;
    const fileName = this.getImageFileName(this.selectedFact);
    if (!fileName) return null;
    if (this.selectedFact['agent_attachedfile.mime'] === 'image/tiff')
      return '/analytics/thumb/' + fileName;
    return `/media/${fileName}`;
  }

  get selectedTargetImage() {
    if (!this.selectedFact) return null;
    const fileName = this.getImageFileName(this.selectedFact);
    if (!fileName) return null;
    return `/media/${fileName}?disposition=inline`;
  }

}

export const FactsSliderViewComponent = {
  bindings: {
    filter: '<',
    selectedFact: '<',
  },
  template: require('./facts-slider-view.component.html'),
  controller: FactsSliderViewController,
};



// WEBPACK FOOTER //
// ./src/facts/slider/facts-slider-view.component.js